<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 131.549 60.639">
    <g id="Other" transform="translate(10739.471 -432.343)">
      <path id="Path_87100" data-name="Path 87100"
        d="M44.289,495.993a12.733,12.733,0,1,0,12.733,12.733,12.748,12.748,0,0,0-12.733-12.733m0,23.279a10.545,10.545,0,1,1,0-21.091h0a10.545,10.545,0,0,1,0,21.091"
        transform="translate(-10680.941 -28.477)" :fill="themeColor" />
      <path id="Path_87101" data-name="Path 87101"
        d="M20.04,495.993a12.733,12.733,0,1,0,12.733,12.733A12.748,12.748,0,0,0,20.04,495.993m0,23.279a10.545,10.545,0,1,1,0-21.091h0a10.545,10.545,0,0,1,0,21.091"
        transform="translate(-10725.955 -28.477)" :fill="themeColor" />
      <path id="Path_87102" data-name="Path 87102"
        d="M18.674,501.48a1.1,1.1,0,0,0,1.091,1.094H47.354a1.094,1.094,0,1,0,.006-2.188H19.771a1.092,1.092,0,0,0-1.1,1.094"
        transform="translate(-10704.854 -20.323)" :fill="themeColor" />
      <path id="Path_87103" data-name="Path 87103"
        d="M7.275,484.773v30.765l-3.636,6.3A1.092,1.092,0,0,0,3.679,523l6.132,9.191a1.091,1.091,0,0,0,.911.486H14.59a1.093,1.093,0,1,0,0-2.185H11.306l-5.433-8.143,3.445-5.967a1.106,1.106,0,0,0,.146-.545V484.773a1.094,1.094,0,1,0-2.188,0"
        transform="translate(-10733.035 -51.336)" :fill="themeColor" />
      <path id="Path_87104" data-name="Path 87104"
        d="M124.373,528.678a1.067,1.067,0,0,0,.023-.52l-2.8-14.53a6.154,6.154,0,0,0-4.5-4.756l-23.067-5.787L80.449,487.527a11.237,11.237,0,0,0-8.466-3.847H4.877a1.1,1.1,0,0,0-.714,1.84,1.072,1.072,0,0,0,.763.346H71.982a9.027,9.027,0,0,1,6.815,3.1l13.8,15.818a1.1,1.1,0,0,0,.56.34L116.546,511a3.941,3.941,0,0,1,2.885,3.039l2.773,14.307-.214.431a4.264,4.264,0,0,1-1.568,1.723l-5.893,2.333a1.1,1.1,0,0,0-.38,1.8c.209.206.4.423.777.317v0a1.048,1.048,0,0,0,.391-.077l5.907-2.316a6.333,6.333,0,0,0,3.148-3.876"
        transform="translate(-10732.339 -51.334)" :fill="themeColor" />
      <path id="Path_87105" data-name="Path 87105"
        d="M6.232,487.735a1.094,1.094,0,1,0,0-2.188h-3a3.221,3.221,0,0,0-3.21,3.213V511.5a3.221,3.221,0,0,0,3.216,3.2H4.658a1.094,1.094,0,1,0,0-2.188H2.2V487.735Z"
        transform="translate(-10739.487 -47.868)" :fill="themeColor" />
      <path id="Path_87106" data-name="Path 87106"
        d="M9.953,487.88l1.471,5.787a8.248,8.248,0,0,0,8.006,6.224H67.961a1.094,1.094,0,1,0,0-2.188H19.444a6.072,6.072,0,0,1-5.89-4.579l-1.48-5.778a1.1,1.1,0,0,0-1.06-.831,1.1,1.1,0,0,0-.943.537,1.091,1.091,0,0,0-.12.828"
        transform="translate(-10721.105 -46.071)" :fill="themeColor" />
    </g>
  </svg>


</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
